module.exports = __webpack_public_path__ + "img/6.7fe545d2.png";